import request from "@/utils/request";

//获取banner
function getBanner() {
    return request.get('/cms/section/ac_store_banner_list')
}
//获取店铺列表
function getStoreList() {
    return request.get('/cms/section/ac_store_list')
}
export default {
    getBanner,
    getStoreList
}